"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import type { MegaMenuCTA as CTAType } from "@/lib/navigation";
interface MegaMenuCTAProps {
  cta: CTAType;
  onClick: () => void;
}
export function MegaMenuCTA(t0) {
  const $ = _c(20);
  const {
    cta,
    onClick
  } = t0;
  const t1 = cta.href;
  const t2 = cta.variant === "primary" ? "bg-primary text-white hover:bg-primary/90" : "border border-primary text-primary hover:bg-primary/10";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex items-center justify-between p-4 rounded-lg btn-hover-nav group", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== cta.label) {
    t4 = <div className="font-medium">{cta.label}</div>;
    $[2] = cta.label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== cta.description || $[5] !== cta.variant) {
    t5 = cta.description && <div className={cn("text-sm mt-0.5", cta.variant === "primary" ? "text-white/80" : "text-zinc-500")}>{cta.description}</div>;
    $[4] = cta.description;
    $[5] = cta.variant;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = cta.variant === "primary" ? "text-white" : "text-primary";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("w-5 h-5 transition-transform group-hover:translate-x-1", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <ArrowRight className={t8} />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== cta.href || $[15] !== onClick || $[16] !== t3 || $[17] !== t6 || $[18] !== t9) {
    t10 = <Link href={t1} onClick={onClick} className={t3}>{t6}{t9}</Link>;
    $[14] = cta.href;
    $[15] = onClick;
    $[16] = t3;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}